module.exports = __webpack_public_path__ + "static_pc/img/fjs.6b81d3c5.png";